import { Component } from "excalibur";

export class XpDropComponent extends Component {
  constructor(public amount: number) {
    super();
  }
}
